export const getNewTargetWeight = (currentWeight: number | string | null | boolean) =>
  currentWeight ? (Number(currentWeight) * 0.8).toFixed(0) : null;
